export const internalRolePrefix = '#internal:';
export const isInternalRole = (roleName) => roleName.startsWith(internalRolePrefix);
